import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { INDICATOR } from '@/api/rest/resources/types/IndicatorProduct';
import {
  METHODOLOGY_EXPLAINER_PAGE_CARBON_COOLFARMTOOL_CO2_SPATIALISE_INDICATORS,
  METHODOLOGY_EXPLAINER_PAGE_CARBON_INDICATORS,
} from '@/config/constants';
import { useGetIndicatorProductSubscriptions } from '@/hooks/useDashboardIndicatorProductSubscription';

import {
  Explainer,
  ExplainerBody,
  ExplainerContent,
  ExplainerCopy,
  ExplainerTitle,
  ExplainerTrigger,
  MethodologyLink,
} from './Explainer';

export const CarbonExplainer = () => {
  const { t } = useTranslation();

  const ipSubscriptions = useGetIndicatorProductSubscriptions().data?.results ?? [];

  const isSubscribedToCoolfarmtoolSpatialise = ipSubscriptions.find(
    (sub) => sub.indicator_product.name === INDICATOR.COOLFARMTOOL_CO2_SPATIALISE,
  );

  return (
    <Explainer>
      <ExplainerTrigger data-testid='carbon-explainer'>
        {t('shared.ncaDetail.details.labels.howDoWeMeasureThis')}
      </ExplainerTrigger>
      <ExplainerContent>
        <ExplainerTitle>{t('shared.ncaDetail.details.carbon.explainers.howDoMeasureThis.headline')}</ExplainerTitle>
        <Stack className='items-start pb-6'>
          <ExplainerBody>
            <ExplainerCopy
              title={t('shared.ncaDetail.details.carbon.explainers.howDoMeasureThis.carbonBelowGroundTitle')}
              body={t(
                isSubscribedToCoolfarmtoolSpatialise
                  ? 'shared.ncaDetail.details.carbon.explainers.howDoMeasureThis.carbonBelowGroundBodySpatialise'
                  : 'shared.ncaDetail.details.carbon.explainers.howDoMeasureThis.carbonBelowGroundBody',
              )}
            />
            <ExplainerCopy
              title={t('shared.ncaDetail.details.carbon.explainers.howDoMeasureThis.emissionsTitle')}
              body={t('shared.ncaDetail.details.carbon.explainers.howDoMeasureThis.emissionsBody')}
            />
            {/* TODO: MVP-5260 - Bring Confidence Interval back to charts  */}
            {/* <ExplainerCopy
              title={t('shared.ncaDetail.details.explainers.howDoMeasureThis.confidenceInterval.title')}
              body={t('shared.ncaDetail.details.explainers.howDoMeasureThis.confidenceInterval.body')}
            /> */}
          </ExplainerBody>
          <MethodologyLink
            to={
              isSubscribedToCoolfarmtoolSpatialise
                ? METHODOLOGY_EXPLAINER_PAGE_CARBON_COOLFARMTOOL_CO2_SPATIALISE_INDICATORS
                : METHODOLOGY_EXPLAINER_PAGE_CARBON_INDICATORS
            }
          />
        </Stack>
      </ExplainerContent>
    </Explainer>
  );
};
